module.exports = __webpack_public_path__ + "img/pd-img12.26f99dcb.png";